// extracted by mini-css-extract-plugin
export var base = "_29-0";
export var updateBanner = "_29-1";